<template>
    <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
      <div v-if="showModal">
        <div class="modal" style="z-index: 1051;" :class="{ 'd-block': showModal }" id="productModal" tabindex="-1" role="dialog"
             aria-labelledby="productModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="productModalLabel">Создать издателя</h5>
                <b-button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePassportModal">
                  <span aria-hidden="true">&times;</span>
                </b-button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="addPassport">
                  <label for="name" style="font-weight: bold;">Название</label>
                  <argon-input
                      id="name"
                      v-model="passportName"
                      :value="passportName"
                      placeholder="Название"
                      :isRequired="true"
                      @change="setPassportName"
                  />

                  <argon-button
                      variant="fill"
                      color="primary"
                      type="submit"
                  >Cоздать
                  </argon-button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
</template>

<script>
import axios from "@/axios";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import velocity from "velocity-animate";

export default {
  name: "ClientCreatePassport",
  components: {
    ArgonInput,
    ArgonButton,
  },
  data() {
    return {
      formErrors: {
        name: false,
        equipmentCost: false,
        rentCost: false,
        qty: false
      },
    };
  },
  computed: {
    passportName: {
      get() {
        return this.$store.state.passportCreateName;
      },
    },
    showModal: {
      get() {
        return this.$store.state.createPassportModal;
      },
    }
  },
  methods: {
    addPassport() {
        const request = {
          name: this.passportName,
        };
        axios.post('/api/clients/passport-issuer-create', request).then((response) => {
          this.fetchPassportAuthors(response.data.data.id, response.data.data.name);
          this.closePassportModal();
          this.clearPassportName();
        });
    },

    fetchPassportAuthors(id, name) {
      axios.get('/api/clients/pasport_autors').then(response => {
        this.setPassportAuthors(response.data);
        this.$store.commit('updatePassportIssuingAuthorityId', id);
        this.$store.commit('updatePassportFilterAuthor', name);
      }).catch(error => {
        console.error("Ошибка загрузки данных: ", error);
      });
    },
    setPassportAuthors(passports){
      this.$store.commit('updatePassportAuthors', passports);
    },
    setPassportName(payload) {
      this.$store.commit('updateCreatePassportName', payload.target.value);
    },
    clearPassportName() {
      this.$store.commit('updateCreatePassportName', null);
    },
    closePassportModal() {
      this.$store.commit('updatePassportModal', false);
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      velocity(el, {opacity: 1}, {duration: 500, complete: done});
    },
    leave(el, done) {
      velocity(el, {opacity: 0}, {duration: 500, complete: done});
    }
  },
};
</script>
